import axios, { AxiosResponse } from 'axios';

import { EStavZadostiDok } from 'enums/dokumentyEnums';

type DateTimeString = string;

export enum ECisOmStav {
    KEKONTROLE = 'KEKONTROLE', // Ke kontrole
    ODSOUHLAS = 'ODSOUHLAS', // Odsouhlasen
    ZAMITNUT = 'ZAMITNUT', // Zamítnut
    EXPIROVAL = 'EXPIROVAL' // Expiroval
}

export enum ECisOmTypUctu {
    PREVOD = 'PREVOD', // převodce
    NABYV = 'NABYV' // nabyvatel
}

export enum ECisOmExpiraceOut {
    OK = 'OK',
    IDNEEXISTUJE = 'IDNEEXISTUJE', // tlinearid požadavku v databázi neexistuje
    JIZEXPIROVAL = 'JIZEXPIROVAL' // požadavek již má nastaven stav EXPIROVAL
}

export enum EOmezPrevodVyjadreni {
    SOUHLAS = 'SOUHLAS', // Souhlasí
    NESOUHLAS = 'NESOUHLAS' // Nesouhlasí
}

export interface IOmPrehledInput {
    isin?: string;
    tlinearid?: string;
    datum?: string;
    datumexp?: string;
    stav?: ECisOmStav;
    prevodceUcet?: string;
    prevodce?: string;
    nabyvatelUcet?: string;
    nabyvatel?: string;
    pocetcp?: number;
    rliv?: string;
    order?: string;
    limit?: number;
    offset?: number;
}

export interface IOmPrevodUcet {
    id?: number;
    typ: ECisOmTypUctu;
    alinearid: string;
    plinearid: string;
    pjma: string;
    jmma?: string;
    ttma?: string;
}

export interface IOmPrevod {
    id?: number;
    idprik?: number;
    isin: string;
    tlinearid: string;
    qtet: number;
    rliv?: string;
    dttransfer: DateTimeString;
    dtexpirace?: DateTimeString;
    stav: ECisOmStav;
    dokstav?: EStavZadostiDok;
    prevodce: IOmPrevodUcet;
    nabyvatel: IOmPrevodUcet;
}

export interface IOmPrehledOut {
    count?: number;
    order?: string;
    limit?: number;
    offset?: number;
    pozadavky?: IOmPrevod[];
}

export const omDetailGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKom/${id}/detail`
    }).then((resp: AxiosResponse<IOmPrevod>) => resp.data);
};

export const omPrehledGet = (params?: IOmPrehledInput) => {
    return axios({
        method: 'GET',
        url: '/DOKom/prehled',
        params: params
    }).then((resp: AxiosResponse<IOmPrehledOut>) => resp.data);
};
